import { useUIColors } from '@/core/hooks';
import FileTextSvg from '@assets/images/svg/file-text.svg';
import React from 'react';
import { View } from 'react-native';

export interface FileTextIconProps {
    size?: number;
    color?: string;
}

export const FileTextIcon = React.memo<FileTextIconProps>(function FileTextIcon({
    size = 20,
    color = '#333333',
}) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <FileTextSvg width={size} height={size} color={color} />
        </View>
    );
});

export default FileTextIcon;
